/**
 * This file contains cache tags for RTKQ
 * https://redux-toolkit.js.org/rtk-query/usage/automated-refetching#invalidating-cache-data
 *
 * Each endpoint in the cache has an associated TAG used when needed in order to refresh the cached endoint data after a POST, DELETE mutation
 * https://redux-toolkit.js.org/rtk-query/usage/automated-refetching#invalidating-cache-data
 *
 * Usage:
 *    - define your the cache tags for type of data [Routes, Route, Customers, Customer] with format CACHE_TAG_[ENDPOINT_DATA_TYPE]
 *
 *    - Import new tag into `api/index` and add as new line with trailing comma on the `tagTypes` collection
 *    - Import new tag into your api slice `api/[apiSliceFolder]/[apiSliceFille]`
 *      add a new prop `providesTags` to the endpoint definition after `query` i.e. `providesTags: CACHE_TAG_[ENDPOINT_DATA_TYPE]`
 */
/* ACCOUNT */
export const CACHE_TAG_ACCOUNTING_PERIOD_LOCK = 'AccountingPeriodLock'
export const CACHE_TAG_ACCOUNTS_LINKED_TO_RENTAL_FEE = 'AccountsLinkedToRentalFee'
export const CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST = 'AccountBeneficialOwnerList'
export const CACHE_TAG_ACCOUNT_DETAILS = 'AccountDetails'
export const CACHE_TAG_ACCOUNT_DETAILS_BY_ID = 'AccountDetailsById'
export const CACHE_TAG_ACCOUNT_EMAIL_EVENT_LIST = 'EmailEventList'
export const CACHE_TAG_ACCOUNT_EXPANDABLE_VIEW = 'AccountExpandableView'
export const CACHE_TAG_ACCOUNT_GROUPS_BY_AGING_BUCKET_SUMMARY = 'AccountGroupsByAgingBucketSummary'
export const CACHE_TAG_ACCOUNT_GROUPS_BY_SUSPENDED_SUMMARY = 'AccountGroupsBySuspendedSummary'
export const CACHE_TAG_ACCOUNT_GROUP_DETAILS = 'AccountGroupDetails'
export const CACHE_TAG_ACCOUNT_GROUP_LIST = 'AccountGroupList'
export const CACHE_TAG_ACCOUNT_GROUP_SUMMARY_DETAILS = 'AccountGroupSummaryDetails'
export const CACHE_TAG_ACCOUNT_INVOICE_LIST = 'AccountInvoiceList'
export const CACHE_TAG_ACCOUNT_LIST = 'AccountList'
export const CACHE_TAG_ACCOUNT_LOCATION_DETAILS = 'LocationList'
export const CACHE_TAG_ACCOUNT_LOCATION_LIST = 'LocationList'
export const CACHE_TAG_ACCOUNT_META = 'AccountMeta'
export const CACHE_TAG_ACCOUNT_NOTES_LIST = 'AccountNotesList'
export const CACHE_TAG_ACCOUNT_PAYMENT_LIST = 'AccountPaymentList'
export const CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST = 'AccountPaymentMethodList'
export const CACHE_TAG_ACCOUNT_RECEIVABLES_LIST = 'AccountReceivablesList'
export const CACHE_TAG_ACCOUNT_RECEIVABLES_SUMMARY = 'AccountReceivablesSummary'
export const CACHE_TAG_ACCOUNT_SETTINGS = 'AccountSettings'
export const CACHE_TAG_ACCOUNT_STATEMENT_LIST = 'StatementList'
export const CACHE_TAG_ACTION_BASED_PRICES_LIST = 'ActionPricesList'
export const CACHE_TAG_AGING_GROUP_DETAILS = 'AgingGroupDetails'
/* BILLING */
export const CACHE_TAG_BILLING_AR_LIST = 'BillingARList'
export const CACHE_TAG_BILLING_INVOICE_GROUP_AGING_BUCKET_DATA = 'BillingInvoiceGroupAgingBucketData'
export const CACHE_TAG_BILLING_INVOICE_GROUP_DETAILS = 'BillingInvoiceGroupDetails'
export const CACHE_TAG_BILLING_INVOICE_GROUP_EMAIL_SUMMARY_DATA = 'BillingInvoiceGroupEmailSummaryData'
export const CACHE_TAG_BILLING_INVOICE_GROUP_LIST = 'BillingInvoiceGroupList'
export const CACHE_TAG_BILLING_MANUAL_INVOICE_LIST = 'BillingManualInvoiceList'
export const CACHE_TAG_BILLING_NOTES_LIST = 'BillingNotesList'
export const CACHE_TAG_BILLING_PAYMENT_GROUP_DETAILS = 'BillingPaymentGroupDetails'
export const CACHE_TAG_BILLING_PAYMENT_GROUP_LIST = 'BillingPaymentGroupList'
export const CACHE_TAG_BILLING_PAYMENT_LIST = 'BillingPaymentList'
export const CACHE_TAG_BILLING_PAYMENT_BATCH_LIST = 'BillingPaymentBatchList'
export const CACHE_TAG_BILLING_PAYMENT_BATCH_BY_ID = 'BillingPaymentBatchById'
export const CACHE_TAG_CALLS_LIST = 'CallsList'
/* CONFIGURED SERVICE */
export const CACHE_TAG_CONFIGURED_SERVICES_LIST = 'ConfiguredServicesList'
export const CACHE_TAG_CONFIGURED_SERVICE_DETAILS = 'ConfiguredServiceDetails'
export const CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST = 'ConfiguredServiceEventList'
export const CACHE_TAG_CONFIGURED_SERVICE_NOTES_LIST = 'ConfiguredServiceNotesList'
export const CACHE_TAG_CONFIGURED_SERVICE_GENERAL_FEES = 'ConfiguredServiceGeneralFees'
export const CACHE_TAG_CONFIGURED_SERVICE_TAXES = 'ConfiguredServiceTaxes'
export const CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES = 'ConfiguredServiceRentalFees'

export const CACHE_TAG_CONTACT_LIST_BY_ACCOUNTS = 'ContactListByAccounts'
export const CACHE_TAG_CONTAINER_LIST = 'ContainerList'
export const CACHE_TAG_CREDIT_LIMIT_HISTORY = 'CreditLimitHistory'
export const CACHE_TAG_DISPOSAL_FEES = 'DisposalFees'
export const CACHE_TAG_DISPOSAL_TICKET_LIST = 'DisposalTicketList'
export const CACHE_TAG_FOLLOW_UP_LIST = 'FollowUpList'
export const CACHE_TAG_INVOICE_LIST = 'InvoiceList'
/* LATE FEES  */
export const CACHE_TAG_LATE_FEES = 'LateFees'
export const CACHE_TAG_LATE_FEE_INSTANCE_SEARCH = 'LateFeeInstanceSearch'
export const CACHE_TAG_LOCATIONS_NOTES_COUNT = 'LocationsNotesCount'
export const CACHE_TAG_LOCATION_NOTES_LIST = 'LocationNotesList'
export const CACHE_TAG_PORTAL_USER_LIST = 'PortalUserList'
export const CACHE_TAG_PRICED_SERVICES_LINKED_TO_RENTAL_FEE = 'PricedServicesLinkedToRentalFee'
export const CACHE_TAG_PRICED_SERVICES_LIST = 'PricedServicesList'
/* RENTAL FEES */
export const CACHE_TAG_RENTAL_FEES = 'RentalFees'
export const CACHE_TAG_RENTAL_FEES_LINKED_TO_ACCOUNT = 'RentalFeesLinkedToAccount'

/* ROUTES */
export const CACHE_TAG_ROUTES = 'RoutesList'
export const CACHE_TAG_ROUTES_STOPS = 'RoutesStops'
// Every stop list but the board's lanes, which a move invalidates by route id instead.
export const CACHE_TAG_ROUTE_STOP_LISTS = 'RouteStopLists'
export const CACHE_TAG_ROUTES_GEOJSON = 'RoutesGeojson'
export const CACHE_TAG_ROUTES_TIMESTAMPS = 'RoutesTimestamps'
export const CACHE_TAG_ROUTES_METADATA = 'RoutesMetadata'
export const CACHE_TAG_ROUTES_METADATA_BY_DATE = 'RoutesMetadataByDate'
export const CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS = 'RoutesUnassignedWorkOrders'
export const CACHE_TAG_MASTER_ROUTE_BRANCH_LIST = 'MasterRouteBranchList'
export const CACHE_TAG_MASTER_ROUTE_META = 'MasterRouteMeta'
export const CACHE_TAG_MASTER_ROUTE_VERSIONS = 'MasterRouteVersions'
// Independent of CACHE_TAG_ROUTES_STOPS. Used by the master-sequence
// reconcile query (`getMasterStopsReconcile`) so a background metadata
// refresh stays in its own cache slot and isn't wiped by mutations that
// invalidate the primary stops cache — keeps in-flight preview/restore/
// move state on the user's grid while we still see fresh server data.
export const CACHE_TAG_MASTER_ROUTE_STOPS_RECONCILE = 'MasterRouteStopsReconcile'
export const CACHE_TAG_DAILY_ROUTE_VERSIONS = 'DailyRouteVersions'
export const CACHE_TAG_ROUTE_DAY_PRODUCTIVITY = 'RouteDayProductivity'
export const CACHE_TAG_ROUTE_OPTIMIZATION_JOB = 'RouteOptimizationJob'
export const CACHE_TAG_DISPOSAL_SERVICE_LIST = 'DisposalServiceList'
export const CACHE_TAG_DISPOSAL_STOP_LIST = 'DisposalStopList'

export const CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE = 'ServicesLinkedToDisposalFee'
export const CACHE_TAG_SERVICE_EXPANDABLE_VIEW = 'ServiceExpandableView'
export const CACHE_TAG_SETTINGS_AUTOPAY = 'SettingsAutoPay'
export const CACHE_TAG_SETTINGS_INVOICE = 'SettingsInvoice'
export const CACHE_TAG_SETTINGS_BILLING_GENERAL_LIST = 'SettingsBillingGeneralList'
export const CACHE_TAG_SUSPENSION_GROUP_DETAILS = 'SuspensionGroupDetails'
export const CACHE_TAG_SUSPENSION_HISTORY = 'SuspensionHistory'
export const CACHE_TAG_TAGS_METADATA = 'Tags'
export const CACHE_TAG_VACATION_HOLD_LIST = 'VacationHoldList'
/* WORK ORDER */
export const CACHE_TAG_WORK_ORDER_COUNT = 'WorkOrderCount'
export const CACHE_TAG_WORK_ORDER_DETAILS = 'WorkOrderDetails'
export const CACHE_TAG_WORK_ORDER_LIST = 'WorkOrderList'
export const CACHE_TAG_WORK_ORDER_LIST_CS_SECTION = 'WorkOrderListCSSection'
export const CACHE_TAG_WORK_ORDER_LIST_SUMMARY = 'WorkOrderListSummary'
export const CACHE_TAG_WORK_ORDER_LIST_SUMMARY_CS_SECTION = 'WorkOrderListSummaryCSSection'
export const CACHE_TAG_WORK_ORDER_LIST_SUMMARY_WO_SECTION = 'WorkOrderListSummaryWOSection'
export const CACHE_TAG_WORK_ORDER_LIST_WO_SECTION = 'WorkOrderListWOSection'
export const CACHE_TAG_WORK_ORDER_NOTES_LIST = 'WorkOrderNotesList'
export const CACHE_TAG_WORK_ORDER_REVIEW_LIST = 'WorkOrderReviewList'
export const CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET = 'WorkOrderDisposalTicket'
export const CACHE_TAG_WORK_ORDER_ROUTE_ACTIVITY_LIST = 'WorkOrderRouteActivityList'
export const CACHE_TAG_SETTINGS_INTEGRATION = 'SettingsIntegration'
/* VERSIONS */
export const CACHE_TAG_CONFIGURED_SERVICE_VERSION_LIST = 'ConfiguredServiceVersionList'
export const CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST = 'ConfiguredServiceEventVersionList'
export const CACHE_TAG_CONTAINER_VERSION_LIST = 'ContainerVersionList'
export const CACHE_TAG_EVENTS_VERSION_LIST = 'EventsVersionList'
export const CACHE_TAG_ACCOUNTS_VERSION_LIST = 'AccountsVersionList'
export const CACHE_TAG_PAYMENT_TERMS_CONFIG = 'PaymentTermsConfig'
export const CACHE_TAG_TAG_REF_VERSION_LIST = 'TagRefVersionList'
export const CACHE_TAG_ADDRESS_VERSION_LIST = 'AddressVersionList'
export const CACHE_TAG_CONTACT_VERSION_LIST = 'ContactVersionList'
export const CACHE_TAG_CONTACT_VERSION_REFS = 'ContactVersionRefs'
export const CACHE_TAG_WORK_ORDER_VERSION_REFS = 'WorkOrderVersionRefs'
export const CACHE_TAG_WORK_ORDER_STATUS_HISTORY = 'WorkOrderStatusHistory'
export const CACHE_TAG_WORK_ORDER_VERSION_LIST = 'WorkOrderVersionList'
export const CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST = 'DisposalTicketVersionList'
export const CACHE_TAG_WORK_ORDER_NOTE_VERSION_LIST = 'WorkOrderNoteVersionList'
export const CACHE_TAG_WORK_ORDER_FEE_TAX_LINE_VERSION_LIST = 'WorkOrderFeeTaxLineVersionList'
export const CACHE_TAG_EXCEPTION_VERSION_LIST = 'ExceptionVersionList'
export const CACHE_TAG_INVOICE_VERSION_LIST = 'InvoiceVersionList'
export const CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST = 'RentalFeeToCSVersionList'
export const CACHE_TAG_RENTAL_PERIOD_VERSION_LIST = 'RentalPeriodVersionList'
export const CACHE_TAG_LATE_FEE_VERSION_LIST = 'LateFeeVersionList'
/* INVENTORY */
export const CACHE_TAG_INVENTORY_CONTAINER_LIST = 'InventoryContainerList'
export const CACHE_TAG_INVENTORY_CONTAINER_MOVE_LIST = 'InventoryContainerMoveList'
export const CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST = 'ConfiguredServiceContainerList'
export const CACHE_TAG_WORK_ORDER_CONTAINER_LIST = 'WorkOrderContainerList'
export const CACHE_TAG_WORK_ORDER_CONTAINER_VERSION_LIST = 'WorkOrderContainerVersionList'
export const CACHE_TAG_ACCOUNT_CONTAINER_LIST = 'AccountContainerList'
export const CACHE_TAG_CONTAINER_TYPE_LIST = 'ContainerTypeList'
export const CACHE_TAG_CONTAINER_COLOR_LIST = 'ContainerColorList'
export const CACHE_TAG_SNAP_TO_ROAD_BATCH = 'SnapToRoadBatch'
export const CACHE_TAG_SNAP_TO_ROAD_RESULTS = 'SnapToRoadResults'
/* SETTINGS */
export const CACHE_TAG_YARD_LIST = 'YardList'
export const CACHE_TAG_DISPOSAL_SITE_LIST = 'DisposalSiteList'
/* ACCOUNT BILLING SETTINGS */
export const CACHE_TAG_SUSPENSION_PRORATION = 'SuspensionProration'
export const CACHE_TAG_SUSPENSION_AUTOMATION = 'SuspensionAutomation'
export const CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS = 'AccountRentalFeeSettings'
export const CACHE_TAG_SUSPENSION_PRORATION_VERSION_LIST = 'SuspensionProrationVersionList'
export const CACHE_TAG_SUSPENSION_AUTOMATION_VERSION_LIST = 'SuspensionAutomationVersionList'
export const CACHE_TAG_RENTAL_BILLING_SETTINGS_VERSION_LIST = 'RentalBillingSettingsVersionList'
export const CACHE_TAG_BILLING_PROFILE_VERSION_LIST = 'BillingProfileVersionList'

export const CACHE_TAG_BRAND_REGISTRATION = 'BrandRegistration'
export const CACHE_TAG_BROADCAST_LIST = 'BroadcastList'
export const CACHE_TAG_BROADCAST_DETAIL = 'BroadcastDetail'
export const CACHE_TAG_BROADCAST_DRAFT_LIST = 'BroadcastDraftList'
export const CACHE_TAG_BROADCAST_DRAFT = 'BroadcastDraft'
export const CACHE_TAG_ALL_CUSTOMER_LISTS = 'AllCustomerLists'
export const CACHE_TAG_CUSTOMER_LIST_DETAIL = 'CustomerListDetail'
export const CACHE_TAG_CUSTOMER_LIST_MEMBERS = 'CustomerListMembers'
export const CACHE_TAG_CAMPAIGN_REGISTRATION = 'CampaignRegistration'
export const CACHE_TAG_PROVISIONED_NUMBER = 'ProvisionedNumber'
export const CACHE_TAG_SMS_PRIVACY_POLICY_CONFIG = 'SmsPrivacyPolicyConfig'
export const CACHE_TAG_SUPPRESSION_LIST = 'SuppressionList'
export const CACHE_TAG_MESSAGING_LEGAL_ACCEPTANCE = 'MessagingLegalAcceptance'
export const CACHE_TAG_TENANT_SETTINGS = 'TenantSettings'
export const CACHE_TAG_NOTIFICATION_LIST = 'NotificationList'
export const CACHE_TAG_NOTIFICATION_ITEMS = 'NotificationItems'
export const CACHE_TAG_NOTIFICATION_PREFERENCES = 'NotificationPreferences'
export const CACHE_TAG_NOTIFICATION_UNREAD_COUNT = 'NotificationUnreadCount'
export const CACHE_TAG_ACCOUNT_LIFECYCLE_REASON_LIST = 'AccountLifecycleReasonList'
export const CACHE_TAG_ACCOUNT_LIFECYCLE_COMPETITOR_LIST = 'AccountLifecycleCompetitorList'
export const CACHE_TAG_ACCOUNT_LIFECYCLE_SETTINGS = 'AccountLifecycleSettings'

/* VISION EXCEPTIONS */
export const CACHE_TAG_EXCEPTIONS_DASHBOARD = 'ExceptionsDashboard'
export const CACHE_TAG_DETECTIONS_LIST = 'DetectionsList'
export const CACHE_TAG_DETECTION_DETAILS = 'DetectionDetails'
export const CACHE_TAG_QUICK_REVIEW_QUEUE = 'QuickReviewQueue'

/* BUSINESS INFO */
export const CACHE_TAG_BUSINESS_INFO = 'BusinessInfo'

/* INSPECTIONS */
export const CACHE_TAG_INSPECTION_LIST = 'InspectionList'
export const CACHE_TAG_INSPECTION_DETAILS = 'InspectionDetails'

/* BUSINESS UNITS */
export const CACHE_TAG_BUSINESS_UNIT_LIST = 'BusinessUnitList'

/* TAXES REDESIGN */
export const CACHE_TAG_TAX_LIST = 'TaxList'
export const CACHE_TAG_ZONE_LIST = 'ZoneList'
export const CACHE_TAG_ZONE_ACTIVITY = 'ZoneActivity'
export const CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS = 'GeoZoneLocationExclusions'
export const CACHE_TAG_TAX_APPLICATION = 'TaxApplication'
export const CACHE_TAG_TAX_RATES = 'TaxRates'
export const CACHE_TAG_TAX_ACTIVITY = 'TaxActivity'
export const CACHE_TAG_TAX_COUNTS = 'TaxCounts'
export const CACHE_TAG_TAX_IMPACT = 'TaxImpact'
export const CACHE_TAG_TAX_FILTER_OPTIONS = 'TaxFilterOptions'

export const CACHE_TAG_TYPES = [
  CACHE_TAG_ROUTES_METADATA,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTE_STOP_LISTS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_TIMESTAMPS,
  CACHE_TAG_MASTER_ROUTE_BRANCH_LIST,
  CACHE_TAG_MASTER_ROUTE_META,
  CACHE_TAG_MASTER_ROUTE_VERSIONS,
  CACHE_TAG_DAILY_ROUTE_VERSIONS,
  CACHE_TAG_ROUTE_DAY_PRODUCTIVITY,
  CACHE_TAG_ROUTE_OPTIMIZATION_JOB,
  CACHE_TAG_DISPOSAL_SERVICE_LIST,
  CACHE_TAG_DISPOSAL_STOP_LIST,
  CACHE_TAG_TAGS_METADATA,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_REVIEW_LIST,
  CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
  CACHE_TAG_DISPOSAL_TICKET_LIST,
  CACHE_TAG_ACCOUNT_RECEIVABLES_SUMMARY,
  CACHE_TAG_ACCOUNT_RECEIVABLES_LIST,
  CACHE_TAG_CONFIGURED_SERVICES_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_DETAILS,
  CACHE_TAG_CALLS_LIST,
  CACHE_TAG_FOLLOW_UP_LIST,
  CACHE_TAG_ACCOUNT_INVOICE_LIST,
  CACHE_TAG_ACCOUNT_PAYMENT_LIST,
  CACHE_TAG_INVOICE_LIST,
  CACHE_TAG_BILLING_AR_LIST,
  CACHE_TAG_BILLING_PAYMENT_LIST,
  CACHE_TAG_BILLING_MANUAL_INVOICE_LIST,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_ROUTE_ACTIVITY_LIST,
  CACHE_TAG_ACCOUNT_EMAIL_EVENT_LIST,
  CACHE_TAG_VACATION_HOLD_LIST,
  CACHE_TAG_PORTAL_USER_LIST,
  CACHE_TAG_BILLING_INVOICE_GROUP_LIST,
  CACHE_TAG_BILLING_INVOICE_GROUP_DETAILS,
  CACHE_TAG_BILLING_INVOICE_GROUP_AGING_BUCKET_DATA,
  CACHE_TAG_WORK_ORDER_COUNT,
  CACHE_TAG_BILLING_PAYMENT_GROUP_LIST,
  CACHE_TAG_BILLING_PAYMENT_GROUP_DETAILS,
  CACHE_TAG_BILLING_PAYMENT_BATCH_LIST,
  CACHE_TAG_BILLING_PAYMENT_BATCH_BY_ID,
  CACHE_TAG_ACCOUNT_META,
  CACHE_TAG_ACCOUNT_NOTES_LIST,
  CACHE_TAG_LOCATION_NOTES_LIST,
  CACHE_TAG_LOCATIONS_NOTES_COUNT,
  CACHE_TAG_WORK_ORDER_NOTES_LIST,
  CACHE_TAG_BILLING_NOTES_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_NOTES_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES,
  CACHE_TAG_ACCOUNT_DETAILS,
  CACHE_TAG_ACCOUNT_DETAILS_BY_ID,
  CACHE_TAG_ACCOUNT_LOCATION_LIST,
  CACHE_TAG_ACCOUNT_LOCATION_DETAILS,
  CACHE_TAG_ACCOUNT_LIST,
  CACHE_TAG_CONTACT_LIST_BY_ACCOUNTS,
  CACHE_TAG_ACCOUNT_GROUP_LIST,
  CACHE_TAG_ACCOUNT_GROUP_DETAILS,
  CACHE_TAG_SUSPENSION_HISTORY,
  CACHE_TAG_ACCOUNT_GROUP_SUMMARY_DETAILS,
  CACHE_TAG_ACCOUNT_GROUPS_BY_AGING_BUCKET_SUMMARY,
  CACHE_TAG_SUSPENSION_GROUP_DETAILS,
  CACHE_TAG_AGING_GROUP_DETAILS,
  CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST,
  CACHE_TAG_RENTAL_FEES,
  CACHE_TAG_DISPOSAL_FEES,
  CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE,
  CACHE_TAG_PRICED_SERVICES_LIST,
  CACHE_TAG_ACCOUNT_STATEMENT_LIST,
  CACHE_TAG_CREDIT_LIMIT_HISTORY,
  CACHE_TAG_PRICED_SERVICES_LINKED_TO_RENTAL_FEE,
  CACHE_TAG_ACCOUNTS_LINKED_TO_RENTAL_FEE,
  CACHE_TAG_RENTAL_FEES_LINKED_TO_ACCOUNT,
  CACHE_TAG_SETTINGS_AUTOPAY,
  CACHE_TAG_SETTINGS_INVOICE,
  CACHE_TAG_SETTINGS_BILLING_GENERAL_LIST,
  CACHE_TAG_ACCOUNTING_PERIOD_LOCK,
  CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST,
  CACHE_TAG_CONTAINER_LIST,
  CACHE_TAG_ACTION_BASED_PRICES_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST,
  CACHE_TAG_SETTINGS_INTEGRATION,
  CACHE_TAG_CONFIGURED_SERVICE_VERSION_LIST,
  CACHE_TAG_CONTAINER_VERSION_LIST,
  CACHE_TAG_EVENTS_VERSION_LIST,
  CACHE_TAG_ACCOUNTS_VERSION_LIST,
  CACHE_TAG_PAYMENT_TERMS_CONFIG,
  CACHE_TAG_ADDRESS_VERSION_LIST,
  CACHE_TAG_CONTACT_VERSION_LIST,
  CACHE_TAG_CONTACT_VERSION_REFS,
  CACHE_TAG_WORK_ORDER_VERSION_REFS,
  CACHE_TAG_WORK_ORDER_STATUS_HISTORY,
  CACHE_TAG_WORK_ORDER_VERSION_LIST,
  CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST,
  CACHE_TAG_WORK_ORDER_NOTE_VERSION_LIST,
  CACHE_TAG_EXCEPTION_VERSION_LIST,
  CACHE_TAG_WORK_ORDER_FEE_TAX_LINE_VERSION_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST,
  CACHE_TAG_INVENTORY_CONTAINER_LIST,
  CACHE_TAG_INVENTORY_CONTAINER_MOVE_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST,
  CACHE_TAG_WORK_ORDER_CONTAINER_LIST,
  CACHE_TAG_WORK_ORDER_CONTAINER_VERSION_LIST,
  CACHE_TAG_ACCOUNT_CONTAINER_LIST,
  CACHE_TAG_SNAP_TO_ROAD_BATCH,
  CACHE_TAG_SNAP_TO_ROAD_RESULTS,
  CACHE_TAG_INVOICE_VERSION_LIST,
  CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST,
  CACHE_TAG_RENTAL_PERIOD_VERSION_LIST,
  CACHE_TAG_LATE_FEE_VERSION_LIST,
  CACHE_TAG_CONTAINER_TYPE_LIST,
  CACHE_TAG_CONTAINER_COLOR_LIST,
  CACHE_TAG_YARD_LIST,
  CACHE_TAG_DISPOSAL_SITE_LIST,
  CACHE_TAG_TAG_REF_VERSION_LIST,
  CACHE_TAG_SUSPENSION_PRORATION,
  CACHE_TAG_SUSPENSION_AUTOMATION,
  CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS,
  CACHE_TAG_SUSPENSION_PRORATION_VERSION_LIST,
  CACHE_TAG_SUSPENSION_AUTOMATION_VERSION_LIST,
  CACHE_TAG_RENTAL_BILLING_SETTINGS_VERSION_LIST,
  CACHE_TAG_BILLING_PROFILE_VERSION_LIST,
  CACHE_TAG_BRAND_REGISTRATION,
  CACHE_TAG_BROADCAST_LIST,
  CACHE_TAG_BROADCAST_DETAIL,
  CACHE_TAG_BROADCAST_DRAFT_LIST,
  CACHE_TAG_BROADCAST_DRAFT,
  CACHE_TAG_ALL_CUSTOMER_LISTS,
  CACHE_TAG_CUSTOMER_LIST_DETAIL,
  CACHE_TAG_CUSTOMER_LIST_MEMBERS,
  CACHE_TAG_EXCEPTIONS_DASHBOARD,
  CACHE_TAG_INSPECTION_LIST,
  CACHE_TAG_INSPECTION_DETAILS,
  CACHE_TAG_DETECTIONS_LIST,
  CACHE_TAG_DETECTION_DETAILS,
  CACHE_TAG_QUICK_REVIEW_QUEUE,
  CACHE_TAG_CAMPAIGN_REGISTRATION,
  CACHE_TAG_PROVISIONED_NUMBER,
  CACHE_TAG_SMS_PRIVACY_POLICY_CONFIG,
  CACHE_TAG_SUPPRESSION_LIST,
  CACHE_TAG_TAX_LIST,
  CACHE_TAG_ZONE_LIST,
  CACHE_TAG_ZONE_ACTIVITY,
  CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS,
  CACHE_TAG_TAX_APPLICATION,
  CACHE_TAG_TAX_RATES,
  CACHE_TAG_TAX_ACTIVITY,
  CACHE_TAG_TAX_COUNTS,
  CACHE_TAG_TAX_IMPACT,
  CACHE_TAG_TAX_FILTER_OPTIONS,
  CACHE_TAG_MESSAGING_LEGAL_ACCEPTANCE,
  CACHE_TAG_TENANT_SETTINGS,
  CACHE_TAG_NOTIFICATION_LIST,
  CACHE_TAG_NOTIFICATION_ITEMS,
  CACHE_TAG_NOTIFICATION_PREFERENCES,
  CACHE_TAG_NOTIFICATION_UNREAD_COUNT,
  CACHE_TAG_BUSINESS_UNIT_LIST,
  CACHE_TAG_ACCOUNT_LIFECYCLE_REASON_LIST,
  CACHE_TAG_ACCOUNT_LIFECYCLE_COMPETITOR_LIST,
  CACHE_TAG_ACCOUNT_LIFECYCLE_SETTINGS,
  CACHE_TAG_BUSINESS_INFO,
]
